import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { ResidentService } from '../resident.service';
import { MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef,  MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { ResidentGroupForCreationResponse, deleteResidentGroup} from '../resident';
import { ResGroup, getGroupData, getGroupNotification } from '../../../api';
import { ApiService } from '../../../api.service';
import { AddResidentGroupComponent } from './add-resident-group/add-resident-group.component';
import { EditresidentgroupComponent } from './edit-resident-group/edit-resident-group.component';
import { enumUIFeatureView, enumUIAction, enumUIView } from '../../../app-settings';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck ,generateAlertMessage, AuthFailedMessage,getFeatureNeedtoShow, getAddEditDeleteColumn} from '../../../app-general';
import {Router} from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmMessageComponent } from '../../../confirm-message/confirm-message.component';
@Component({
  selector: 'app-show-resident-group',
  templateUrl: './show-resident-group.component.html',
  providers: [ ResidentService ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./show-resident-group.component.scss']
})
export class showResidentGroupComponent implements OnInit,OnDestroy {

  ResGroup: ResGroup[];
  dataSource;
  dataSourcecount = 1;
  displayedColumns: string[] = ['GroupName', 'Description', 'Residents', 'Count', 'Edit', 'Delete'];
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  resCount = 0;
  SiteId = "1";
  bAddEdit:boolean=false;
  bDelete:boolean=false;
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<showResidentGroupComponent>, @Inject(MAT_DIALOG_DATA) public data: string,
  private residentService: ResidentService,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService,public dialog: MatDialog) {
    mediaObserver.media$.subscribe((change: MediaChange) => {
      if (getFeatureNeedtoShow(enumUIFeatureView.Resident_Group, enumUIAction.Resident_Group_AddEditDelete) == enumUIView.Show) {
        this.bAddEdit = true;
        this.bDelete = true;
      }
      
          if (change.mqAlias == this.xscurrentScreenWidth) {
              this.setupTableforXtrasmallerwidth();
          }
          else if (change.mqAlias == this.smcurrentScreenWidth) {
              this.setupTableforsmallerwidth();
          }
           else
          {
            this.setupFullTable();
          }

      });
   }

  ngOnInit() {  
    if (getFeatureNeedtoShow(enumUIFeatureView.Resident_Group, enumUIAction.Resident_Group_AddEditDelete) == enumUIView.Show) {
      this.bAddEdit = true;
      this.bDelete = true;
    }
    this.getResidentGroup();
  }

setupTableforXtrasmallerwidth() {
    this.displayedColumns = ['GroupName', ,'Count','Edit', 'Delete'];    
    this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);
};

setupTableforsmallerwidth() {
    this.displayedColumns = ['GroupName','Residents', 'Count', 'Edit', 'Delete'];
    this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);  
};

setupFullTable() {
    this.displayedColumns = ['GroupName', 'Description', 'Residents', 'Count', 'Edit', 'Delete'];
    this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);
};
  public onCloseCancel = () => {
   
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
  }

  getResidentGroup(): void{
    try
    {
      var resgroupitem : getGroupData = {authKey: localStorage.getItem("Authkey")}
      this.apiService.getResidentGroup(resgroupitem).pipe(takeUntil(this._onDestroy))
      .subscribe((ResGroup : any[])=>{
        if(ResGroup["apiReturn"] == "Invalid Auth Key")
        {  
            this.thisDialogRef.close('Cancel');                
            AuthFailedMessage(this.dialog,this.router);  
            return;       
        } 
        this.ResGroup = ResGroup["apiReturn"];       
        this.dataSource = new MatTableDataSource(this.ResGroup);          
        this.dataSource.data = this.ResGroup;                   
        this.dataSourcecount= this.dataSource.data.length; 
      });
    }
    catch (err) {
      throw new Error('show-resident-group.component.ts' + ' - getResidentGroup() - ' + err.message);
    }
  }

 
  /*********Add Resident group dialogwindow*******/
  AddResidentGroup() { 
    if(!SessionCheck(this.router))
    {
      this.thisDialogRef.close('Cancel');
        return;
    }
    let dialogRef = this.dialog.open(AddResidentGroupComponent, {
      disableClose: true,
      width: '550px',
      height:'300px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {      
      if(result == "Confirm")   
          this.getResidentGroup();
      else
      {
        if(!SessionCheck(this.router))
        {
          this.thisDialogRef.close('Cancel');
            return;
        }
      }
    })
}

/////////////////*********Edit resident group******/
editResidentGroupdata(Groupid: number, Groupname: string,description: string)
{   
  if(!SessionCheck(this.router))
  {
    this.thisDialogRef.close('Cancel');
      return;
  } 
    let ResidentGroupDetail = { GroupId: Groupid, Groupname: Groupname, Description: description};

    let dialogRef = this.dialog.open(EditresidentgroupComponent, {
      disableClose: true,
      width: '550px',
      height:'300px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: ResidentGroupDetail
      
    });
    
    dialogRef.afterClosed().subscribe(result => {       
      if(result == "Confirm")   
           this.getResidentGroup(); 
      else
      {
        if(!SessionCheck(this.router))
        {
          this.thisDialogRef.close('Cancel');
            return;
        }
      }
    })

}

////////////////////Delete Resident Group////////////

deleteResidentGroupdata(Groupid: number)
{  
  if(!SessionCheck(this.router))
  {
    this.thisDialogRef.close('Cancel');
      return;
  }      
  this.getGroupNotificationInfo(Groupid);  
}
getGroupNotificationInfo(Groupid)
{
  try
  {    
    var ConfirmMessageData = {
      ConfirmMessage: "Are you sure you want to delete this Group?"                  
    }     
    let dialogRef = this.dialog.open(ConfirmMessageComponent, {
      disableClose: true,
      width: 'auto',
      height: '220px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: ConfirmMessageData
    });     
    dialogRef.afterClosed().subscribe(result => {     
      if(result == "Yes")
      {                             
        var DeleteResidentgroup : getGroupNotification = {siteId:this.SiteId, authKey: localStorage.getItem("Authkey"),groupId:parseInt(Groupid),groupType:0}        
        this.apiService.getGroupNotificationInfo(DeleteResidentgroup).pipe(takeUntil(this._onDestroy))
          .subscribe((apigroupresponse : any[])=>{              
            if(apigroupresponse.toString() == "Success")
            {
              this.deleteResidentGroup(Groupid)              
            }
            else
            {
              generateAlertMessage(this.dialog, "This '"+apigroupresponse[0].GroupName+"' is in escalation level, so please remove this group from escalation and try again.")
            }
          })                         
      }
      else
      {
          dialogRef.close('Cancel');
          return;
      }
    });
  }
  catch(err)
  {
      throw new Error('delete-resident-group.ts' + ' - getGroupNotificationInfo() - ' + err.message);
  }   
}

deleteResidentGroup(Groupid)
{
  var DeleteResidentgroup : deleteResidentGroup = 
  {    
    authKey: localStorage.getItem("Authkey"),
    groupId:parseInt(Groupid)
  }
   this.residentService.deleteResidentGroup(DeleteResidentgroup).pipe(takeUntil(this._onDestroy))
     .subscribe((apiresponse : ResidentGroupForCreationResponse[])=>{                
       if(apiresponse["apiReturn"] == "Success")
       {         
         generateAlertMessage(this.dialog, 'Resident group deleted successfully.')	             
       }
       else if(apiresponse["apiReturn"] == "Fail")
       {
         generateAlertMessage(this.dialog, 'Resident group deleted failed.')              
       }
       else if(apiresponse["apiReturn"] == "Invalid Auth Key")
       {   
           this.thisDialogRef.close('Cancel');                              
           AuthFailedMessage(this.dialog,this.router);  
           return;       
       } 
       else
       {
         generateAlertMessage(this.dialog, apiresponse.toString())             
       }
       this.getResidentGroup();           
     });
}
ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}

}
